import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { HiOutlineCalendar, HiOutlineLocationMarker, HiOutlineUserGroup } from "react-icons/hi";
import axios from "axios";
import Cookies from "js-cookie";

function UpcomingEvents() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const token = Cookies.get("userToken");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/apis/admin/getAllUpComingEvent`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEvents(response.data.message || []);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  const handleEventClick = () => navigate("/event");

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  // Skeleton Loader Component
  const EventSkeleton = () => (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden border border-indigo-100 animate-pulse">
      <div className="flex p-4">
        <div className="w-20 h-20 rounded-lg bg-gradient-to-r from-indigo-200 to-purple-200"></div>
        <div className="ml-4 flex-1 space-y-2">
          <div className="h-4 w-3/4 bg-indigo-200 rounded"></div>
          <div className="h-3 w-1/2 bg-indigo-200 rounded"></div>
          <div className="h-3 w-full bg-indigo-200 rounded"></div>
          <div className="h-3 w-4/5 bg-indigo-200 rounded"></div>
          <div className="h-4 w-24 bg-indigo-200 rounded mt-3"></div>
        </div>
      </div>
    </div>
  );

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      <div className="flex items-center space-x-2 px-2">
        <div className="w-8 h-8 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg flex items-center justify-center">
          <HiOutlineCalendar className="w-4 h-4 text-white" />
        </div>
        <h2 className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
          Upcoming Events
        </h2>
      </div>
      
      {loading ? (
        <>
          <EventSkeleton />
          <EventSkeleton />
        </>
      ) : events.length > 0 ? (
        events.slice(0, 2).map((event, index) => (
          <motion.div
            key={event._id}
            variants={itemVariants}
            custom={index}
            whileHover={{ y: -4 }}
            className="bg-white/90 backdrop-blur-sm rounded-xl shadow-md overflow-hidden border border-indigo-100 hover:shadow-lg transition-all duration-300"
          >
            <div className="flex p-4">
              <img
                src={event.image || "assets/event1.png"}
                alt="Event"
                className="w-20 h-20 rounded-lg object-cover border-2 border-indigo-200"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "assets/default-event.png";
                }}
              />
              <div className="ml-4 flex-1">
                <h3 className="font-semibold text-gray-800">
                  {event.adminProfile?.collegeName || "College Event"}
                </h3>
                <p className="text-sm text-indigo-600 mt-1 font-medium line-clamp-1">
                  {event.title || "Annual College Festival"}
                </p>
                <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                  {event.description || "Join us for music, dance and cultural performances. Open to all students."}
                </p>
                <motion.button
                  whileHover={{ x: 5 }}
                  onClick={handleEventClick}
                  className="mt-3 text-indigo-600 text-sm font-medium flex items-center hover:text-indigo-700 transition-colors"
                >
                  View Details
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </motion.button>
              </div>
            </div>
          </motion.div>
        ))
      ) : (
        <motion.div 
          variants={itemVariants}
          className="bg-white/90 backdrop-blur-sm rounded-xl p-8 text-center border border-indigo-100"
        >
          <div className="w-16 h-16 mx-auto bg-indigo-100 rounded-full flex items-center justify-center mb-3">
            <HiOutlineCalendar className="w-8 h-8 text-indigo-600" />
          </div>
          <p className="text-gray-500">No upcoming events scheduled</p>
        </motion.div>
      )}
    </motion.div>
  );
}

export default UpcomingEvents;